import { render, staticRenderFns } from "./LuConcern.vue?vue&type=template&id=e582a1ae"
import script from "./LuConcern.vue?vue&type=script&lang=js"
export * from "./LuConcern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports